import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import Ad from '@ifeng/ui_pc_ad';
import Search from '@ifeng/ui_pc_search';
import { rel } from '../../../../../utils/rel';

class Logo extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <Fragment>
                <div className={styles.logoBox}>
                    <a href={content.url} target="_blank" rel={rel}>
                        <img src={content.logo} className={styles.logo} />
                    </a>
                    <img src={content.subLogo} className={styles.subLogo} />
                </div>
            </Fragment>
        );
    }
}

/**
 * 定义 LogoSearch 组件
 */
class LogoSearch extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        windowMode: PropTypes.string,
    };

    render() {
        const {
            content: { logo, search, ad_label },
            windowMode,
        } = this.props;

        return (
            <div className={`${styles.logoSearLine} ${windowMode === 'wide' ? styles.wide : null}`}>
                <Chip id="30082" type="struct" title="logo" groupName="头部" content={logo}>
                    <Logo />
                </Chip>
                <div className={styles.label}>
                    <Ad content={ad_label} />
                </div>
                <Search content={search} />
            </div>
        );
    }
}

export default errorBoundary(LogoSearch);
